import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-blue-900 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-271" data-mp="369pga49jt16e">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-272" data-mp="31jhe67m7cct4" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-273" data-mp="31h4nn62dou4g">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-slate-200" data-id="element-274" data-mp="3g7c97unomt9d">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="3b895qencov3i" /> El precio de lanzamiento termina en:
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-276" data-mp="3p80lajtimjjm" />
        <p className="mt-7 font-bold text-slate-200" data-id="element-277" data-mp="3l6ylo1vos5h4">Después sube el precio y no vuelve a bajar.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-slate-300/25 bg-blue-950 p-4 text-left text-sm" data-id="element-278" data-mp="1uu0u3f44c66n">
          <p className="flex items-center justify-between gap-3 font-bold" data-id="element-279" data-mp="1quihd6mgb1ew">
            <span className="inline-flex items-center" data-id="element-280" data-mp="2sufv0bfxjkr0">
              <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" aria-hidden="true" data-id="element-281" data-mp="2srtlw7de4x6o" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-slate-200" data-id="element-282" data-mp="32qj3s05aehmx">Quedan pocos</span>
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-blue-800" data-id="element-283" data-mp="37jcauuo8a226">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="silver-metal h-full rounded-full" data-id="element-284" data-mp="3cif4zk2o6nvd" />
          </div>
          <p className="mt-1 text-right text-xs text-slate-300" data-id="element-285" data-mp="3qgdhsl1cec8r">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-286" data-mp="1r5m2hbq2srmq" />
    </section>;
}